import React, { useState } from "react";
import { Link } from "react-router-dom";

function PolicyForm({ policy, busy, save }) {
  const [enabled, setEnabled] = useState(policy.automatic_drafts);
  const [recipients, setRecipients] = useState(policy.recipients.join(", "));
  const [delay, setDelay] = useState(policy.delay_minutes);
  return (
    <form className="space-y-3" onSubmit={(event) => {
      event.preventDefault();
      save({ automatic_drafts: enabled, recipients: recipients.split(",").map(value => value.trim()).filter(Boolean),
        delay_minutes: Number(delay), expected_revision: policy.revision });
    }}>
      <label className="flex items-center gap-2 text-sm">
        <input type="checkbox" checked={enabled} disabled={busy} onChange={event => setEnabled(event.target.checked)} />
        Automatically prepare this meeting’s follow-up draft
      </label>
      <p className="text-sm text-[#68746d]">After the meeting ends and its notes and actions are reviewed, Timelyzer can prepare a message with the current decisions, owners and deadlines. Background checks must be enabled. Sending requires your review in Outbox.</p>
      <label className="block text-sm font-semibold">
        Follow-up recipients (comma separated emails)
        <input className="field-input mt-1" value={recipients} required={enabled} maxLength={5000} disabled={busy} onChange={event => setRecipients(event.target.value)} />
      </label>
      <label className="block text-sm font-semibold">
        Minutes after the meeting ends
        <input className="field-input mt-1" type="number" min={0} max={10080} required value={delay} disabled={busy} onChange={event => setDelay(event.target.value)} />
      </label>
      <p className="text-xs text-[#68746d]">Recipients apply to this meeting only. Cancelled drafts stay cancelled; uncertain sends require checking their result. After a confirmed send, further messages are prepared manually.</p>
      <button className="secondary-button" disabled={busy}>Save follow-up settings</button>
    </form>
  );
}

export default function MeetingFollowups({ data, busy, save }) {
  if (!data) return null;
  return (
    <section className="surface-panel space-y-4 p-5" aria-label="Meeting follow-up delivery">
      <h2 className="text-lg font-bold">Follow-up delivery</h2>
      <p role="status" className="text-sm">{data.message}</p>
      <PolicyForm key={data.policy.revision} policy={data.policy} busy={busy} save={save} />
      {!!data.history.length && <div className="space-y-3">
        <h3 className="font-semibold">Saved messages</h3>
        {data.history.map(item => <article key={item.id} className="rounded-md border border-[#dce3dd] p-3 text-sm">
          <p className="font-semibold">{item.title}</p>
          <p>{item.status === "sent" ? "Provider acceptance confirmed" : item.status === "needs_review" ? "Delivery uncertain" : item.status === "sending" ? "Send in progress" : item.status === "cancelled" ? "Cancelled" : "Unsent draft"} · {item.automatic ? "Prepared automatically" : "Prepared manually"}</p>
          <p>To: {item.recipients.join(", ")}</p>
          {item.message && <p className="mt-1 text-[#68746d]">{item.message}</p>}
          {item.status === "sent" && <p>Recipient delivery is unconfirmed. Meeting actions remain tracked.</p>}
          <Link className="mt-2 inline-block font-semibold underline" to="/assistant?view=outbox">{["sending", "needs_review"].includes(item.status) ? "Check result in Outbox" : "Review in Outbox"}</Link>
        </article>)}
        {data.more_history && <p className="text-xs">Showing the latest 20 messages.</p>}
      </div>}
    </section>
  );
}
